export const SubProductType = Object.freeze({
  termLoan: 4,
  revolvingCredit: 3,
  bbls: 2,
  cbils: 1,
  recoveryLoanScheme: 5,
});

export const SubProductTypeDataName = Object.freeze({
  [SubProductType.cbils]: 'cbils',
  [SubProductType.bbls]: 'bbls',
  [SubProductType.revolvingCredit]: 'revolvingCredit',
  [SubProductType.termLoan]: 'termLoan',
  [SubProductType.recoveryLoanScheme]: 'recoveryLoanScheme',
});

export const SubProductTypeLabel = Object.freeze({
  [SubProductType.termLoan]: 'Term loan',
  [SubProductType.revolvingCredit]: 'Revolving credit',
  [SubProductType.bbls]: 'BBLS',
  [SubProductType.cbils]: 'CBILS',
  [SubProductType.recoveryLoanScheme]: 'Recovery Loan Scheme',
});

export const toOptions = () =>
  Object.keys(SubProductType).map((subProductKey) => ({
    id: SubProductType[subProductKey],
    value: subProductKey,
    label: SubProductTypeLabel[SubProductType[subProductKey]],
  }));
